import { getStoreUrlByStoreCode } from "asos-site-chrome-store-presentation";
import { getSocialLinks } from "../../i18n/utilities";

import {
  DEFAULT,
  FEMALE,
  MALE
} from "../template/state/modules/layout/constants";

const FLOORS = [DEFAULT, FEMALE, MALE];

export { DEFAULT, FEMALE, MALE };

export const storeUrlsForAllFloors = (storeCode, platform) =>
  FLOORS.reduce(
    (storeUrls, gender) => ({
      ...storeUrls,
      [gender]: getStoreUrlByStoreCode({
        storeCode,
        gender,
        isMobile: platform === "mobile",
        environmentMode: process.env.CLIENT_ENVIRONMENT_MODE
      })
    }),
    {}
  );

export const storeLinksForAllFloors = storeCode =>
  FLOORS.reduce(
    (links, floor) => ({
      ...links,
      [floor]: getSocialLinks({ storeCode, floor })
    }),
    {}
  );



// WEBPACK FOOTER //
// ./helpers/storeUrls.js